import styled from 'styled-components/macro';
import { defaultStyle } from '../../styles/GlobalTheme/GlobalStyles';
import px2vw from '../../utils/px2vw';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    padding-top: 80px;
    padding-bottom: 124px;

    @media only screen and (max-width: 425px) {
        padding-top: 40px;
        padding-bottom: 62px;
    }

    @media only screen and (max-width: 768px) {
        padding-top: 40px;
        padding-bottom: 62px;
    }
`;

export const Title = styled.div`
    color: ${props => props.fontColor || 'black'};
    font-family: ${props => props.theme.fontFamily};
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 30px;
`;

export const Items = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    @media only screen and (max-width: 425px) {
        flex-direction: column;
    }
`;

export const Item = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: 47px;

    @media only screen and (max-width: 425px) {
        margin-top: 33px;
        flex-direction: row;
        align-items: center;
    }
`;

export const ItemIcon = styled.img`
    height: 48px;
    width: 48px;
    @media only screen and (max-width: 425px) {
        height: 30px;
        width: 30px;
    }

    @media only screen and (max-width: 768px) {
        height: 36px;
        width: 36px;
    }
`;

export const ItemText = styled.p`
    font-family: ${props => props.theme.fontFamily};
    font-style: normal;
    font-weight: normal;
    color: ${props => props.fontColor || 'black'};
    font-size: 16px;
    line-height: 24px;
    letter-spacing: ${props => props.theme.subtitleLetterSpacing};
    max-width: ${px2vw(200)};
    margin-top: 25.35px;

    @media only screen and (max-width: 768px) {
        font-size: 14px;
        line-height: 18px;
        max-width: 130px;
    }

    @media only screen and (max-width: 425px) {
        margin-top: 5px;
        margin: auto;
        margin-left: 10px;
        max-width: 100%;
        font-size: 14px;
        line-height: 18px;
    }

    @media only screen and (max-width: 375px) {
        margin-top: 5px;
        margin: auto;
        margin-left: 10px;
        max-width: 500px;
        font-size: 14px;
        line-height: 18px;
    }

    
`;